module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p7"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "chaptertitle paired"
  }, [_vm._v("2002")]), _vm._v(" "), _c('h2', {
    staticClass: "chaptersubtitle "
  }, [_vm._v("Boston, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("“What are you doing here?” the patient asked.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I work here,” Anna said. “Do you know where you are?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I’m in the hospital,” Mrs. Pearl said as she took in her surroundings.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“We met last night when you were admitted. Do you remember?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I’m sorry. I don’t remember,” Mrs. Pearl said.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“That’s okay. We don’t need to remember everything. I’m Dr. Fury. Do you know why you’re here?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Anna studied her patient’s chart. Edith Pearl had been suffering from chronic kidney failure for two years. Her treatment consisted of dialysis three times a week and a strict diet protocol, by which Mrs. Pearl was clearly not abiding.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“The same reason I’m always here,” Mrs. Pearl said in a whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Anna found herself speaking in hushed tones, as if her voice could shatter another’s. “You had excess fluid buildup and we needed to do dialysis. This was only twenty-four hours after your previous dialysis. Have you been keeping track of your fluid intake?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I used to drink four cups of coffee a day. Then water or soda, and then a cocktail before dinner. Now you tell me to chew on ice chips and eat food that has no flavor. I can live without the food, I guess . . . I was playing bridge with my girlfriends, and Lucy made the most delicious lemonade, and I drank a glass and then another glass.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Unfortunately,” Anna said, “you can’t do that anymore. If too much fluid builds up in your body, it stresses your heart and makes it hard for you to breathe.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I have to remind you.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What if I wanted to stop?” Mrs. Pearl asked.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Stop dialysis?” Anna asked.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Have you talked to your family about this?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“This is my decision, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“It is. But you should talk to your family.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What would happen if I stopped treatment?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Toxins would build up. That would cause problems with your heart rhythm.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“And then I would die?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“How long would it take?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Not very long. A week. Maybe less.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Would it hurt?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“The pain could be managed.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Mrs. Pearl diverted her attention to her failing manicure. “Would you look at this?” she said, pointing out a chip in the cotton-candy-pink polish. “I just had them done three days ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“They still look nice,” Anna said.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What would you do?” Mrs. Pearl asked, her voice eggshell thin.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I don’t know,” Anna said. Lying.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“How do you make a decision like that?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“It’s a difficult decision.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I’m always thirsty.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I understand,” Anna said.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TO")]), _vm._v(": Anna Fury")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FROM")]), _vm._v(": Kate Smirnoff")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RE")]), _vm._v(": Bloodletting")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "follow"
  }, [_vm._v("I’ve been reading about this phlebotomy business. What I don’t get is how a procedure that was practiced for three thousand years could have no palliative advantages. So far, I can find none. Sure, I get that the early bloodletting was a crazy religious practice at first and then that it was used to restore the balance of bodily humors. I’m sure you had to be there for that to make sense. But when men of science, capable of some deductive reasoning, got involved, how come they didn’t notice that draining someone’s blood never made him feel any better? The only use for it that makes sense to me is, say, if there was an area that was swollen. I guess if I knew nothing about the human body and was practicing medicine in ancient times, I might find a logical reason to let blood out of a swollen body part. I suppose it’s not that different from lancing a boil.")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "follow"
  }, [_vm._v("You know what else is really funny? That barbers were surgeons way back when. Did you know that the red-and-white barbershop signpost was also the sign for a surgeon? I’m sure they teach all that crap in medical school. Even now, a barber must have steady hands and is trusted with a very sharp blade. If I were a man, I’d never let a barber give me a straight-razor shave. I always hate that procedure when I see it in movies. You’d think there’d be more barbershop murders than there are.")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "follow"
  }, [_vm._v("How are you doing? And please let me know if you can think of any condition in which bloodletting made sense.")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "follow"
  }, [_vm._v("Kate")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TO")]), _vm._v(": Kate Smirnoff")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FROM")]), _vm._v(": Anna Fury")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RE")]), _vm._v(": Bloodletting")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "follow"
  }, [_vm._v("Hi. Your new obsession is intriguingly macabre. Most ancient medicinal practices were more likely to kill you than heal you. Then again, some ghastly measures, like leeching, turned out to be rather useful. Hirudotherapy (the fancy word for the medical use of leeches) made a comeback recently because it can aid postoperative patients who run the risk of blood clots from venous congestion. I’m not sure why bloodletting lasted so long, but there are surely things we are doing right now that one day might seem barbaric. I’d like to say it’s inserting bags of silicone into the chest wall. But I think big tits (or "), _c('em', [_vm._v("proportional breasts")]), _vm._v(", as they were described in my plastics rotation) are here for the duration.")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "follow"
  }, [_vm._v("Enough about medieval medicine. Have you thought about my offer? Why don’t you come for a visit and you’ll see.")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "follow"
  }, [_vm._v("Anna")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("After medical school in St. Louis, Anna was accepted into a residency program in Boston, and so she returned to the cold embrace of her family. Colin was there, which helped, but it wasn’t like she ever saw him. Within six months, she met a man who’d come into the ED after being bitten by his girlfriend’s dog. She looked at his chart. Nick Charles was the name he gave. He must have shown ID and proof of insurance at registration, but she still didn’t believe it.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Nick Charles. Really?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“My sister’s name is Nora.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Were you teased in high school?” Anna asked.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Only by teachers,” Nick said as Anna examined the dog bite.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I would have teased you.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("She treated Nick’s wound and gave him a tetanus shot, and he returned a few days later with flowers and asked her out. It was considered highly unethical for physicians to date patients, and she told him so. Two weeks later, when the wound was a ghost of its former self, he was waiting outside the hospital after Anna’s shift (and he couldn’t have learned her schedule without dedicated effort). He asked her out again, this time adding that he was no longer anyone’s patient. She asked about the girlfriend and the dog. He had dumped both shortly after the bite. He reminded her that life was short. Anna didn’t particularly like this ploy, the constant allusions to 9/11 by people who hadn’t been touched by it at all. But Anna liked his name and so she said yes, although whenever anyone asked how they’d met, she’d say they began chatting at the local farmers’ market (even though she couldn’t remember the last time she’d bought fresh produce). The appeal of Nick Charles was simple: he was nice and he wasn’t a doctor or a lawyer, which somehow seemed important, at least in terms of disappointing her mother. Nick Charles did something with computers, but Anna never asked enough questions to really understand his career. (If Kate had met him, she would have found out that he worked on a compiling team that transformed source code into another programming language, and then she’d be able to explain what that meant.)")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Nick didn’t mind Anna’s lack of interest in his job. Most people, other than his colleagues, lacked interest in it. After they’d been dating for six months, Nick thought they should move in together, but Anna put him off. He couldn’t understand, since she had a two-bedroom apartment and was hardly ever home.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Anna had never felt right about leaving Kate behind. She couldn’t leave her in Santa Cruz after what happened, but then, after she’d dragged her to St. Louis, she didn’t want to leave her in St. Louis, because it was St. Louis. Kate was twenty-seven, alone in the Midwest with just a handful of friends, or acquaintances, depending on how you looked at it. She was on a career track to become the manager of a coffeehouse. Anna couldn’t help but feel responsible. That extra room in Anna’s apartment was for Kate. She wasn’t taking in anyone else.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TO")]), _vm._v(": Anna")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FROM")]), _vm._v(": Kate")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "left "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RE")]), _vm._v(": Bloodletting")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "follow"
  }, [_vm._v("I don’t know what it is, but modern medicine holds no interest for me. I talked to George the other day on the phone. Well, sort of talked to her. Carter was crying and she put the phone down for five minutes. Once she did it for ten, so I decided that five minutes was my absolute maximum hold time. She should play music or something.")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "follow"
  }, [_vm._v("I’ve thought about it. But I really like it here. I’d miss the City Museum. I like the slides a lot and I know the layout. Plus, I have a car now, and I hear it’s really, really hard to park in Boston. As you recall, parallel parking is my weak spot.")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "follow"
  }, [_vm._v("Kate")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("Hi, Anna.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANNA")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("I hate caller ID. I miss hearing the inquisitive “Hello?”")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("Hello?")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANNA")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("Hi, George, it’s Anna.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("What’s up?")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANNA")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("I need you to help me convince Kate to come to Boston for a visit.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("Just a visit?")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANNA")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("Once she visits, it will be easier to convince her to move here.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("I’m not sure it’s a great idea. You two living together again.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANNA")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("I’m an upstanding citizen these days. Besides, Kate’s nearing her three-year anniversary at her café job. Maybe if she moved, she might find a more ambitious career goal beyond master barista.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("You may have a point there. During our last conversation, she pontificated for ten minutes on optimal coffee temperatures. Apparently, French press is the only way to go. What does she talk to you about?")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANNA")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("Bloodletting.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("At least you have something in common. Don’t wake up. Please don’t wake up.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANNA")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("Excuse me?")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("The baby didn’t sleep at all last night. I don’t know what I’m going to do. The crying drives Mitch crazy. He hasn’t been the same since 9/11. I think he has PTSD. He doesn’t like noise.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANNA")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("Are you sure he liked noise before 9/11?")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("I’m not sure what he likes anymore.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANNA")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("Is everything okay?")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("No. Mitch hasn’t been home in three days. He said he was staying in a hotel so he can sleep, but I don’t know which hotel. That’s fucked up, right?")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANNA")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("Well, I’m not married, so I’m not an expert on these things.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("You can be honest.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANNA")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("You should know that’s fucked up without even asking.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("I’ve called him at least twenty times and he doesn’t pick up.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANNA")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("Are you sure he wasn’t in an accident or something?")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("I wish.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANNA")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("Has this happened before?")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("Yes.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANNA")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("Many times?")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("He’s seeing someone, isn’t he?")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANNA")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("May I continue being honest or have you had enough honesty?")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("Continue.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANNA")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("He’s probably seeing someone. Or, if you’re lucky, he’s just got a serious gambling problem. Have you checked his phone?")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("Impossible. He guards that thing as if it contains nuclear launch codes.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANNA")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("Have you ever asked him?")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("Please, please, don’t cry.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANNA")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("We need a transitional code word so I know if you’re talking to me or the baby.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("The baby is crying again.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANNA")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("Babies cry, George. Relax.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("Can you come visit me?")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANNA")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("I’m sorry. I don’t know if I can get away for a while.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("I have to go. I’ll talk to you later.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("KATE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("Hello?")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("It’s George.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("KATE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("I know. Did you get my postcard?")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("Yes, thank you. There’s something you should know. I can’t read your writing. The postcard had a giraffe and the St. Louis Zoo logo on it, but other than that, I got nothing.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("KATE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("They have a baby elephant named Clementine, but that’s not why you’ve called.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("I’ve been dispatched by Anna to convince you to visit her in Boston. So, you should visit her in Boston.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("KATE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("Is that your entire sales pitch?")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GEORGE")]), _vm._v(":   ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "table"
  }, [_vm._v("I’m revising the pitch. Forget Boston. Visit me in New York.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Kate couldn’t refuse once she’d heard the details of the offer: an all-expenses-paid trip to New York City with free rein for Kate to prove that Mitch was the louse she’d always said he was. The visit was entirely undercover. George booked the flight and a hotel room just around the corner from her apartment. When Mitch was convincingly alibied in his office, George and Kate roamed a chilly late-fall Manhattan. When his whereabouts were less certain, Kate tailed him like a private detective. She wore an old pea coat and skullcap as a disguise, though she doubted he would recognize her in any case. He’d hardly seemed to register her presence the few times they’d met.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("On a Wednesday afternoon when Mitch was supposedly at a business lunch, Kate followed him from his office to his mistress’s apartment at Eighty-Second and Fifth. Kate snapped photos of the duo with a tiny digital camera as they emerged from the woman’s apartment, walked down the street hand in hand, and kissed on the corner while they waited for the light to change. She followed him again the next day to establish a pattern. Mitch emerged from his office at lunch and took a taxi to his gym at Lexington and Sixty-Third. Kate sat on a bench reading the newspaper, watching the most well-dressed people she had ever seen in her life enter and exit the sports club, until Mitch emerged an hour and a half later with a different woman, a shockingly underweight but well-toned brunette, on his arm. She followed them six blocks and one avenue to the Four Seasons hotel. Snapped a photo of the couple entering the grand revolving doors. It looked like a shot from a magazine spread.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Kate transferred the images to George’s computer and played the slide show. She was surprised by George’s stillness as she took inventory of her husband’s infidelities. George sighed once, turned off the computer, and retreated to the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“That was just two days, so there may be more,” Kate said.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I’m sure,” George said.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What are you going to do?” Kate asked.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I’m going to have a drink.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“After the drink?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I’m going to do what needs to be done,” George said.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("The next time Mitch returned home after an unexplained and long absence, George didn’t ask him where he had been. She greeted him politely, like the person working the counter at an airline. Within five minutes of Mitch’s return, George left with a simple “Mrs. Klinger is with Carter; I’ll be back.” Two hours later, George came home, sweaty from a pickup basketball game at the gym. She was a member of a different kind of gym than Mitch’s. She acknowledged Mitch with an atypical grunt, walked into the kitchen, and foraged through the refrigerator, savoring the blast of cold air. George chugged straight from a gallon of milk. A string of white liquid trailed a line down her chin to her neck. She wiped it away on the sleeve of her sweatshirt. She cracked open a bag of potato chips, lay down on the couch, and turned on the television. She found the channel that played all of those nature programs that were like horror films for her husband. Mitch watched his wife as if she were a 3-D hologram at a science museum. He circled her on the couch, noted her shoes resting on a white throw pillow, and watched crumbs of potato chips spill onto her sweatshirt as she stared in a daze at the television.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Don’t you want to take a shower?” Mitch asked.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Not right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Do you mind taking off your shoes?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("George kicked her shoes off and onto the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What should we do about dinner?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Sorry, I’ve been bogarting the chips,” George said, tossing the bag in Mitch’s general direction. The bag fell at his feet.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Mrs. Klinger surfaced from Carter’s bedroom, wearing her coat and clutching her handbag.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“He’s asleep,” she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("George walked her to the door.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Thank you, Mrs. Klinger. See you Monday?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Yes, dear,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("After George shut the door, she sniffed her armpit and said, “I guess I’ll take that shower now.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("George spotted a daddy longlegs crawling along the edge of the tub. Her shower ritual often involved the dispatching of any creatures that had found their way into the apartment. Spiders were a particular problem. Mitch had once knocked himself unconscious when he’d tripped over the tub trying to escape a brown house spider. This time, though, George relocated the spider to the glass on the sink. She took a shower, reached for the razor out of habit, then changed her mind. She had a moment more blissful than any she could remember in the entire marriage when she realized that now that it was over, she could do exactly what she wanted. Nothing mattered anymore. Of course George knew that divorce and attorneys and moving out of the apartment and fighting were inevitable, but she decided she’d live in this state of I-don’t-give-a-fuck for a little while longer. Long enough to enjoy it.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("After she toweled off, she returned the spider to the exact location where she’d found it.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("After five days in New York, Kate took the shuttle to Boston. Anna picked her up at the airport. Kate shoved her luggage into the trunk of Anna’s old Volvo, which contained, much to Kate’s pleasure, a spare tire, among Anna’s other incongruous nonessentials: ice skates, hockey puck, throw pillow, toolbox, and an old-fashioned coffee mill.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Kate slipped into the passenger seat and slammed the door.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Was your mission successful?” Anna asked.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I believe it was. We have photographic evidence and everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“It always seemed like such a waste,” Anna said.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“What part?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“She was "), _c('em', [_vm._v("one")]), _vm._v(" year into her career and she gave it all up for him. What was the point of getting an education if she wasn’t going to use it?” Anna said.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“So there’s no point in being informed, having an area of expertise, if you don’t use it? That’s ridiculous. I know all sorts of things that I don’t need to know when I’m steaming milk. And not once have I wished that I hadn’t learned those things.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You know what I mean,” Anna said.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I do,” Kate said. “I just don’t agree with it. She quit her job to get married and have a child, and there’s nothing wrong with that. What’s wrong is that she gave it all up for "), _c('em', [_vm._v("that")]), _vm._v(" guy.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Agreed. So how is she?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Look, I’ve suffered through almost a week of domestic purgatory,” Kate said, “in which I’ve revisited in excruciating detail every aspect of George’s married life. I want to talk about the weather, global warming, rising tides, I want to talk about how sad I am that Marty Feldman is dead—”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“He’s been dead a long time, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I’m still sad about it. Also, I want to talk about the one billion birds that die every year by flying into windows and why we’re not doing anything to stop it. And I want to talk about those whacked-out people who want to amputate perfectly healthy limbs.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“You really want to talk about that?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I want to talk about anything but men.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Anna reached into the back seat and dropped a textbook on Kate’s lap.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Hemochromatosis,” Anna said. “The page is marked.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I know that word,” said Kate.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“That’s what I forgot in my last e-mail. It’s a condition where too much iron builds up in your organs. The treatment is phlebotomy and chelation therapy. The disease is extremely rare, but in medieval times, if you had it, and your barber practiced bloodletting, you’d be in good shape.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Anna pulled her car into the airport traffic, cutting off an SUV.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“That’s so awesome. How rare is the condition?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Extremely rare.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Got a number off the top of your head?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“I don’t have your recall. Must come in handy with all those drink orders.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“More useful when I waitress. There are a limited number of caffeinated beverages. Sometimes you can just look at a person and know what she’ll order.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Your birthday is in two days. What do you want?”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“Pick something or I’ll assume you want a Saint Bernard puppy.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“There "), _c('em', [_vm._v("is")]), _vm._v(" a new book on the plague out.”")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“More plague? Haven’t you learned everything there is to learn?” Anna asked.")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("“There wasn’t just one plague, you know.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b67ee3b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c04.vue
// module id = 81
// module chunks = 0